<template>
  <div class="login">
    <a>
      <img
        src="https://fontmeme.com/permalink/190801/cce39cacf08952ed8af3800340eb7451.png"
        alt="pokemon-font"
        border="0"
      />
    </a>
    <input type="text" v-model="email" placeholder="Email" />
    <br />
    <input type="password" v-model="password" placeholder="Password" />
    <br />
    <div v-if="error">{{error}}</div>
    <button @click="login">
      <img height="50" src="@/assets/gotta-catch.png" />
    </button>
  </div>
</template>

<script>
import firebase from "@/javascript/firebase";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    async login() {
      this.error = "";
      // const sound = new Audio(require('../assets/pikapika.mp3'));
      // sound.play();
      try {
        await firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password);
        this.$router.push({ name: "TheHome" });
      } catch (err) {
        this.error = err;
      }
    }
  }
};
</script>

<style scoped>
.login {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-image: url("../assets/pikachubg.jpg");
  background-position-y: bottom;
}

.login a {
  margin-top: 60px;
}

input {
  margin: 10px auto;
  width: 20%;
  padding: 15px;
}

button {
  margin: 0 40vw;
  cursor: pointer;
  background: #ffe664;
  border: 3px solid black;
  border-radius: 5px;
}

button:hover {
  background-color: red;
  cursor: pointer;
}

p {
  margin-top: 40px;
  font-size: 13px;
}

p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>
